<template>
  <div class="loader" v-if="loading"></div>
  <div class="container page-title-container">
    <div>
      <h1>Performance Management</h1>
    </div>
  </div>

  <!-- Display Details -->
  <div
    v-if="empId != 'ADM01' && this.formType == 'My Forms'"
    class="container details-container py-3"
    style="box-shadow: 2px 3px 10px 0px rgb(122, 122, 122)"
  >
    <div class="d-flex">
      <div class="row">
        <div
          class="col-md-6 my-2"
          v-for="(detail, idx) in this.displayDetails"
          :key="idx"
        >
          {{ detail }}
        </div>
      </div>
    </div>
  </div>

  <div class="container nav-container">
    <div
      v-if="
        empId == 'ADM01' ||
        (this.permissions.includes('Performance-Management-Permission') &&
          this.formType != 'My Forms') ||
        this.formType != 'My Forms'
      "
      class="mb-4"
      style="display: block"
    >
      <div style="margin: 10px 0px; font-weight: bold">
        Departments<span style="color: red">*</span> :
      </div>
      <select
        v-if="formIsBeingEdited"
        ref="departmentsSelect"
        class="custom-select"
        v-model="selectedDepartment"
        disabled
      >
        <option value="" disabled selected>Select</option>

        <option
          v-for="(dept, idx) in departmentsForMultiSelect"
          :key="idx"
          :value="dept.text"
        >
          {{ dept.text }}
        </option>
      </select>
      <select2-multiple-control
        v-if="!formIsBeingEdited"
        ref="departmentsSelect"
        class="mySelect1"
        style="width: 100%; display: block"
        v-model="selectedDepartments"
        :options="departmentsForMultiSelect"
        @change="
          handleChange($event);
          fetchEmployeesByDepartments();
        "
      />
    </div>
    <div>
      <div
        v-if="
          empId === 'ADM01' ||
          (this.permissions.includes('Performance-Management-Permission') &&
            this.formType != 'My Forms') ||
          this.formType != 'My Forms'
        "
        class="mb-4"
      >
        <div style="margin: 10px 0px; font-weight: bold">
          Employee<span style="color: red">*</span> :
        </div>
        <select
          v-if="formIsBeingEdited"
          ref="employeesSelect"
          class="custom-select"
          v-model="selectedEmployee"
          @change="getDetailsOfSelectedEmployee"
          disabled
        >
          <option value="" disabled selected>Select</option>
          <option value="" style="color: red">Clear selection</option>

          <option
            v-for="employee in employees"
            :key="employee.id"
            :value="employee.id"
          >
            {{ employee.text }}
          </option>
        </select>
        <select2-multiple-control
          v-if="!formIsBeingEdited"
          ref="employeesSelect"
          class="mySelect2"
          style="width: 100%; display: block"
          v-model="selectedEmployees"
          :options="employees"
          @change="getDetailsOfSelectedEmployees($event)"
        />
      </div>
    </div>
    <div>
      <div
        v-if="
          empId === 'ADM01' ||
          (this.permissions.includes('Performance-Management-Permission') &&
            this.formType != 'My Forms') ||
          formType != 'My Forms'
        "
        class="d-flex mb-4"
        style="padding: 0px 0px"
      >
        <div class="d-flex flex-column" style="margin-right: 80px">
          <div style="font-weight: bold" class="">
            Appraisal start date<span style="color: red">*</span> :
          </div>
          <input
            type="date"
            style="
              margin: 8px 0px;
              width: 10rem;
              height: 38px;
              border: 1px solid #aaa;
              border-radius: 4px;
              padding: 0px 10px;
            "
            id="review_period"
            name="review_period"
            v-model="review_start_date"
            :disabled="formType != 'All Forms'"
          />
        </div>
        <div class="d-flex flex-column">
          <div style="font-weight: bold; margin-left: 0px" class="">
            Appraisal end date<span style="color: red">*</span> :
          </div>
          <input
            type="date"
            style="
              margin: 8px 0px;
              width: 10rem;
              height: 38px;
              border: 1px solid #aaa;
              border-radius: 4px;
              padding: 0px 10px;
            "
            id="review_period"
            name="review_period"
            v-model="review_end_date"
            :disabled="formType != 'All Forms'"
          />
        </div>
      </div>

      <div
        v-if="
          empId === 'ADM01' ||
          (this.permissions.includes('Performance-Management-Permission') &&
            this.formType != 'My Forms') ||
          this.formType == 'All Forms' ||
          (whoami == 'linemanager' &&
            directReportees.length != 0 &&
            formType != 'My Forms') ||
          (whoami == 'executive' && formType != 'My Forms')
        "
        class="d-flex mb-4"
        style="padding: 0px 0px"
      >
        <div class="d-flex flex-column">
          <div style="font-weight: bold">
            Reviewer due date<span style="color: red">*</span> :
          </div>
          <input
            type="date"
            style="
              margin: 8px 0px;
              width: 10rem;
              height: 38px;
              border: 1px solid #aaa;
              border-radius: 4px;
              padding: 0px 10px;
            "
            v-model="reviewer_due_date"
            :disabled="formType != 'All Forms'"
          />
        </div>
      </div>
      <div v-if="(empId === 'ADM01' ||
      permissions.includes('Performance-Management-Permission') ||
      formType !== 'My Forms')
    " class="mb-4" style="margin-right:70px; display: flex;">
          <div style="font-weight: bold">
            Reviewer Type<span style="color: red">*</span>:
          </div>
          <div class="form-check form-check-inline ml-4 mb-4">
            <input class="form-check-input" type="radio" id="lineManager" value="Line Manager" v-model="this.reviewerType" :disabled="isDisabled" >
            <label class="form-check-label" for="Line Manager">Line Manager</label>
          </div>
          <div class="form-check form-check-inline mb-4">
            <input class="form-check-input" type="radio" id="other" value="Other" v-model="this.reviewerType" :disabled="isDisabled">
            <label class="form-check-label" for="Other">Other</label>
          </div>
          <div v-if="this.selectedReviewer != 'Line Manager'" class="d-flex ">
          <div style="font-weight: bold; margin-left: 70px;">
            Reviewer<span style="color: red">*</span> :
          </div>
          <select class="custom-select" v-model="this.selectedReviewer" :disabled="isDisabled">
            <option value="" disabled selected>Select Reviewer</option>
            <option v-for="reviewer in reviewers" :key="reviewer.employee_id" :value="reviewer.employee_id">
              {{ reviewer.employee_id }} - {{ reviewer.name }}
            </option>
          </select>
      </div>
        </div>
        
    </div>


    <ul class="nav nav-pills" role="tablist">
      <div style="display: flex" class="sleeve">
        <li
          v-for="(tab, index) in section"
          :key="index"
          class="nav-item"
          role="presentation"
        >
          <button
            :class="[
              'nav-link',
              { active: activeTab === tab.id },
              'arrow-button',
            ]"
            style="width: 180px; height: 100%"
            @click="setActiveTab(tab.id, tab)"
            type="button"
            role="tab"
            :aria-controls="tab.id"
            :aria-selected="activeTab === tab.id"
          >
            <span style="min-height: 80px">{{ tab.name }}</span>
          </button>
        </li>
      </div>
      <li
        v-if="
          (empId == 'ADM01' ||
            (this.permissions.includes('Performance-Management-Permission') &&
              formType != 'My Forms'))
        "
        class="btn-container"
        style="list-style: none"
      >
        <button
          type="button"
          class="btn btn-outline-dark new-section-btn"
          @click="addNewSection"
        >
          + Add new section
        </button>
      </li>
    </ul>

    <div class="tab-content">
      <div v-if="this.activeTab != 1" class="d-flex">
        <div
          v-if="
            (empId == 'ADM01' ||
              (this.permissions.includes('Performance-Management-Permission') &&
                formType != 'My Forms'))
          "
          class="new-question-btn my-3"
        >
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="toggleNewQuestion"
          >
            <span v-if="!showNewQuestion"
              >+ Add a<span v-if="activeTab == 1">n entry</span
              ><span v-else-if="activeTab == 2"> competency</span
              ><span v-else-if="activeTab">n objective</span></span
            ><span v-else>Cancel</span>
          </button>
        </div>
        <div
          v-if="showNewQuestion"
          class="new-question-btn my-3"
          style="margin-left: auto"
        >
          <button
            type="button"
            class="btn btn-primary"
            @click="submitNewQuestion"
          >
            <span>Submit</span>
          </button>
        </div>
      </div>

      <Transition>
        <div v-if="showNewQuestion" class="new-question-container">
          <form class="d-flex flex-column" action="">
            <label for="question_text">
              <b>Enter title<span style="color: red">*</span> :</b>
            </label>
            <textarea
              v-model="questionInput"
              id="question_text"
              name="question_text"
              rows="4"
              cols="60"
              required
            ></textarea>
            <!-- My department selection code starts here -->
            <label for="description" style="margin-top: 10px">
              <b>Add description<span style="color: red">*</span> :</b>
            </label>
            <textarea
              v-model="descriptionInput"
              id="description"
              name="description"
              rows="4"
              cols="60"
              required
            ></textarea>
          </form>
        </div>
      </Transition>
      <div
        v-if="this.checkSelectedDepartments() == false && this.activeTab != 1"
      >
        <hr />
        <p style="margin: auto; width: min-content; white-space: nowrap">
          No entries for selected departments!
        </p>
        <hr />
      </div>
      <div
        v-for="(tab, index) in section"
        :key="index"
        class="tab-pane"
        :class="{ active: activeTab === tab.id }"
        :id="tab.id"
        role="tabpanel"
        :aria-labelledby="tab.id"
      >
        <!-- General Overview -->

        <Transition name="general">
          <div class="General-Section" v-if="tab.id == 1">
            <div class="welcomeText my-2">
              <h2>Welcome!</h2>
              You can take a quick glance of your progress here
            </div>
            <div
              v-for="(tab, idx) in this.section.slice(1)"
              :key="idx"
              class="d-flex justify-content-around"
              style="
                margin-top: 40px;
                box-shadow: 2px 3px 10px 5px rgb(204, 204, 204);
                border-radius: 10px;
              "
            >
              <!-- <svg class="radial-task-meter" viewBox="0 0 32 32">
              <circle class="radial-task-progress" :style="progressStyle" cx="16" cy="16" r="15.9155" />
            </svg> -->
              <div
                class="d-flex"
                style="
                  align-items: center;
                  justify-content: center;
                  flex: 0 0 auto;
                  background: linear-gradient(
                    to right,
                    rgb(19, 21, 114) 0%,
                    rgb(83, 72, 245) 60%
                  );
                  color: white;
                  max-width: 30%;
                  min-width: 30%;
                  border-radius: 10px 0px 0px 10px;
                "
              >
                <b
                  ><h4>{{ tab.name.toUpperCase() }}</h4></b
                >
              </div>
              <div
                class="d-flex w-100 task-counters-container justify-content-around"
                style="padding: 20px"
              >
                <div class="d-flex-column">
                  <div
                    style="
                      margin: auto;
                      width: min-content;
                      white-space: nowrap;
                      margin-bottom: 10px;
                    "
                  >
                    <b>Tasks Completed: </b>
                  </div>
                  <TaskCounter
                    :completedTasks="
                      this.employeeId !== ''
                        ? getCompletedTasks(
                            tab.questions.filter((ele) => ele.published == true)
                          )
                        : 0
                    "
                    :totalTasks="
                      this.employeeId !== ''
                        ? tab.questions.filter(
                            (ele) =>
                              ele.published == true &&
                              ele.form_id == formId &&
                              ele.employee_id == selectedEmployee
                          ).length
                        : 0
                    "
                  ></TaskCounter>
                </div>
                <div class="d-flex-column">
                  <div
                    style="
                      margin: auto;
                      width: min-content;
                      white-space: nowrap;
                      margin-bottom: 10px;
                    "
                  >
                    <b>Tasks In Progress: </b>
                  </div>
                  <TaskCounter
                    :completedTasks="
                      this.employeeId !== ''
                        ? tab.questions.filter(
                            (ele) =>
                              ele.published == true &&
                              ele.form_id == formId &&
                              ele.employee_id == selectedEmployee
                          ).length -
                          getCompletedTasks(
                            tab.questions.filter((ele) => ele.published == true)
                          )
                        : 0
                    "
                    :totalTasks="
                      this.employeeId !== ''
                        ? tab.questions.filter(
                            (ele) =>
                              ele.published == true &&
                              ele.form_id == formId &&
                              ele.employee_id == selectedEmployee
                          ).length
                        : 0
                    "
                  ></TaskCounter>
                </div>
              </div>
            </div>
            <div class="dropdown-tab row" style="margin-top: 40px; ">
              <div class="col-md-12">
                <div class="d-flex-column">
                  <label style="font-size: 0.9rem;">
                    <b>Final Comments: </b>
                  </label>
                  <textarea v-model="finalComments" rows="7" cols="40" placeholder="Enter your response" style="padding: 5px; width: 100%;" @input="receiveDataFromQuestion('', 'Final Comments', 'all')" @blur="clearBufferObj('all')" :disabled="!permissions.includes('Final-Review-Permission') || finalSubmitted == true || formStatus == 'Inactive'"></textarea>
                </div>
                <!-- <div class="mt-2" style="margin-left: auto; width: min-content">
                  <button class="btn btn-primary" @click="updateQuestion(userId, questionId)">Submit</button>
                </div> -->
              </div>
            </div>
          </div>
        </Transition>
        <!--General Overview ends-->
        <div v-for="(question, idx) in tab.questions" :key="idx">
          <!-- <div v-if="((empId == 'ADM01' && selectedEmployees.length != 0) || (empId != 'ADM01'))"> -->
          <div
            v-if="this.displayedQuestions.some((ele) => ele.id == question.id)"
          >
            <Question
              ref="questionComponents"
              :mode="'edit'"
              :formType="formType"
              :formStatus="formStatus"
              :questionText="question.question_text"
              :description="question.description_text"
              :departments="emp_department"
              :userId="empId"
              :sectionId="this.activeTab"
              :questionId="question.id"
              :questionEmpId="question.employee_id"
              :questionEmpName="question.users.name"
              :storedEmpResponse="question.employee_response"
              :storedRevResponse="question.reviewer_response"
              :storedProgress="question.progress"
              :storedAttachment="question.attachment"
              :published="question.published"
              :submitted="question.submitted"
              :reviewerSubmitted="question.reviewer_submitted"
              :permissions="permissions"
              @progress-change="addToProgress"
              @getAllSections="this.getAllSections"
              @EmployeeEOR="this.clearBufferObj"
              @ReviewerEOR="this.clearBufferObj"
              @loading="this.showLoading"
            />
          </div>
        </div>
        <div
          v-if="
            this.activeTab !== 1 &&
            this.checkSelectedDepartments() &&
            (tab.questions.length == 0)
          "
        >
          <hr />
          <p style="text-align: center">No entries for this section!</p>
          <hr />
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="
      (((formType == 'My Forms'  || formType == 'Team Forms') && this.activeTab !== 1) || permissions.includes('Final-Review-Permission'))
    "
    class="action-buttons-container"
  >
    <div class="action-buttons-holder">
      <button
        type="button"
        class="btn btn-secondary ml-3"
        style=""
        @click="goBack"
      >
        <span class="bi bi-arrow-left mr-1"></span> Back
      </button>
      <button
        type="button"
        class="btn btn-info ml-3"
        @click="saveForm(true)"
        :disabled="
          (permissions.includes('Final-Review-Permission') && ((formType == 'All Forms' || formType == 'Team Forms') &&
            finalSubmitted)) ||
          ((formType == 'My Forms' && submitted) ||
          ((formType == 'Team Forms') &&
            reviewerSubmitted) || 
          dateCheck)
        "
      >
        Save
      </button>
      <button
        v-if="this.activeTab == Object.keys(this.section).length"
        type="button"
        class="btn btn-primary ml-3"
        @click="submitForm"
        :disabled="
          (permissions.includes('Final-Review-Permission') && ((formType == 'All Forms' || formType == 'Team Forms') &&
            finalSubmitted)) ||
          (formType == 'My Forms' && submitted) ||
          ((formType == 'Team Forms') &&
            reviewerSubmitted) ||
          dateCheck
        "
      >
        Submit
      </button>
    </div>
  </div>
  <div
    v-if="formType == 'All Forms' && permissions.includes('Performance-Management-Permission') && this.activeTab !== 1"
    class="action-buttons-container"
  >
    <div class="action-buttons-holder container">
      <div
        class="d-flex align-items-center px-2"
        style="
          margin-right: auto;
          background-color: rgb(70, 70, 70);
          border-radius: 10px;
        "
      >
        <div style="color: white">
          Status:
          <span v-if="reviewerSubmitted" style="color: rgb(217, 236, 218)"
            >Reviewed</span
          >
          <span v-else-if="submitted" style="color: rgb(78, 169, 230)"
            >Submitted</span
          >
          <span style="color: rgb(5, 197, 5)" v-else-if="published"
            >Published</span
          >
          <span v-else style="color: rgb(233, 236, 42)">Unpublished</span>
        </div>
      </div>
      <button type="button" class="btn btn-secondary ml-3" @click="goBack">
        <span class="bi bi-arrow-left mr-1"></span> Back
      </button>
      <button
        v-if="!createMode"
        type="button"
        class="btn btn-danger ml-3"
        @click="deleteForm"
        :disabled="hideSelect"
      >
        Delete
      </button>
      <button
        v-if="showSaveButton"
        type="button"
        class="btn btn-primary ml-3"
        @click="saveChanges(true)"
      >
        Save
      </button>
      <button
        type="button"
        class="btn btn-dark ml-3"
        @click="publishForm"
        :disabled="hideSelect"
      >
        Publish
      </button>
    </div>
  </div>
</template>

<script>
import Question from '../components/Question';
import TaskCounter from '../components/TaskCounter';
import $ from 'jquery';
import Select2MultipleControl from 'v-select2-multiple-component';
import axios from 'axios';
import { decryptData } from '../js/utils/encrypt';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import all from '../assets/all.png';
import australia from '../assets/australia.png';
import china from '../assets/china.png';
import hongkong from '../assets/hong-kong.png';
import india from '../assets/india.png';
import japan from '../assets/japan.png';
import malaysia from '../assets/malaysia.png';
import philippines from '../assets/philippines.png';
import singapore from '../assets/singapore.png';

export default {
  components: {
    Question,
    Select2MultipleControl,
    TaskCounter,
  },
  computed: {
  isDisabled() {
    return !(this.empId === 'ADM01' || this.permissions.includes('Performance-Management-Permission'));
  }
},
  watch: {
    employees: function () {
      $('.mySelect2').trigger('change');
    },

    submitted(newVal, oldVal) {
      console.log('watching subm: ', [oldVal, newVal]);
    },

    reviewerType(newVal) {
      if (newVal === 'Line Manager') {
        this.selectedReviewer = 'Line Manager'; // Set to 'Line Manager' when selected
      } else if (newVal === 'Other' && this.reviewers.length > 0) {
        this.selectedReviewer = this.reviewers[0].employee_id; // Default to the first reviewer when 'Other' is selected
      }
    },
    selectedReviewer(newVal) {
      console.log(newVal)
      this.updateReviewerType();
    }
  },
  provide() {
    return {
      receiveDataFromQuestion: this.receiveDataFromQuestion,
    };
  },
  data() {
    return {
      permissions: [],
      all: all,
      australia: australia,
      china: china,
      hongkong: hongkong,
      india: india,
      japan: japan,
      malaysia: malaysia,
      philippines: philippines,
      singapore: singapore,
      selectedDepartment: '',
      selectedDepartments: [],
      myDetails: [],
      encryptedEmailID: '',
      encryptedEmployeeID: '',
      descriptionInput: '',
      employeeId: '',
      empId: '',
      empDept: '',
      employeeData: '',
      managerData: '',
      review_end_date: '',
      initialReviewEndDate: '',
      review_start_date: '',
      initialReviewStartDate: '',
      reviewer_due_date: '',
      initialReviewerDueDate: '',
      dateCheck: false,
      reviewers:[],
      selectedReviewer: '',
       reviewerType:'',
      displayDetails: {
        empName: '',
        empDept: '',
        empRole: '',
        reviewer: '',
        reviewPeriod: '',
        reviewDate: '',
      },
      formId: '',
      formType: '',
      formStatus: '',
      activeTab: 1, // Set the initially active tab
      tabQuestions: [],
      questionInput: '',
      section: [],
      questions: [],
      showNewQuestion: false,
      selectAll: false,
      departments: [],
      selectAllDepartments: false,
      noQuestionsFlag: false,
      allResponses: {},
      allProgresses: [],
      selectedEmployee: '', // Holds the selected employee ID
      selectedEmployees: [],
      selectedEmployeeInfo: '',
      selectedEmployeesInfo: {},
      employees: [],
      bufferObj: {},
      shownQuestions: [],
      displayedQuestions: [],
      whoami: 'linemanager',
      directReportees: [],
      hideSelect: false,
      published: false,
      submitted: false,
      reviewerSubmitted: false,
      showSaveButton: true,
      formIsBeingEdited: false,
      createMode: true,
      emp_department: '',
      finalComments: '',
      finalSubmitted: false,
    };
  },

  mounted() {
    //Decrypting Permissions

    this.updateReviewerType();
    this.fetchReviewers();

    let mkLocalData = localStorage.getItem('Permissions');
    if (!mkLocalData) {
      mkLocalData = 'null';
    }
    const secretPermissionKey = process.env.KEY || 'myscecretkey';
    this.permissions = decryptData(mkLocalData, secretPermissionKey);

    //Done for Leave Admin and Executive role
    if (this.permissions.includes('Leave-Admin')) {
      this.whoami = 'leaveadmin';
    } else if (this.permissions.includes('Executive')) {
      this.whoami = 'executive';
    }

    this.encryptedEmployeeID = localStorage.getItem('EmployeeID');
    this.encryptedEmailID = localStorage.getItem('Email');
    // const secretKey = process.env.KEY || 'myscecretkey';
    // this.employeeId = decryptData(this.encryptedEmployeeID, secretKey).replace(
    //   /['"]+/g,
    //   ''
    // );

    this.getDetails();
  },
  methods: {
    async getDetails() {
      this.loading = true;
      this.getDepartments();
      // console.log('form_id',this.formId);
      this.setDefaultOptions();
      this.getAllSections();

      // console.log('this is the empId',this.employeeId);
      await axios
        .post(this.$hostName + '/getEmployeeAndReviewerDetailsByFormId', {
          empId: this.employeeId,
          form_id: this.formId,
        }).then((response)=>{
          // console.log('Response:', response.data);
        this.employeeDetails = response.data.employeeDetails[0];
        this.reviewerDetails = response.data.reviewerDetails[0];
        })

    // console.log('this.employeeDetails',this.employeeDetails);
    // console.log('this.reviewerDetails',this.reviewerDetails);
      await axios
        .post(this.$hostName + '/myInfo', {
          year: new Date().getFullYear(),
          empId: this.employeeId,
        })
        .then((response) => {
          this.employeeData = response.data[0]['employeeData'][0];
          // this.managerData = response.data[4]['managerData'][0];
          // this.ReviewerNames = response.data[6]['ReviewerNames'];
          if (this.employeeData.hasOwnProperty('name')) {
            this.displayDetails.empName =
              'Employee Name: ' + this.employeeData.name;
          }
          this.empId = this.employeeData.empid;
          if (this.employeeData.department) {
            this.empDept = this.employeeData.department.deparment;
            this.displayDetails.empDept =
              'Department: ' + this.employeeDetails.deparment;
          } else {
            this.empDept = this.employeeData.department;
            this.displayDetails.empDept =
              'Department: ' + this.employeeDetails.department;
          }
          this.displayDetails.empRole =
            'Role Title: ' + this.employeeData.position;
            if (this.reviewerDetails.name) {
            this.displayDetails.reviewer =
              'Reviewer Name: ' + this.reviewerDetails.name;
          }
          // this.displayDetails.reviewPeriod = 'Review Period: ' + new Date().toLocaleDateString();
          // this.displayDetails.reviewDate = 'Review Date: ' + this.Date().toLocaleDateString();
          // console.log('this.ReviewerNames', this.reviewerDetails.name);
          // console.log('this.managerData', this.managerData.name);
          // this.setDefaultOptions();
          // console.log('here is the form_id',this.formId);
          // this.getQuestionsOfSelectedEmployees();
        })
        .catch((error) => {
          console.error('Error is happening at 2nd axios call: ', error);
          // console.error(error);
        })
        .finally(() => {
          // this.loading = false;
        });

      axios
        .post(this.$hostName + '/getManagerDirectReportees', {
          empid: this.employeeId,
          whoami: this.whoami,
        })
        .then((response) => {
          this.directReportees = response.data[1].directReportsData;
          // this.reporteesLeaveBal = response.data[2];
          // this.whoamiLocation = response.data[0].employeeData[0].location;
          // console.log('reportttttttttteee',this.directReportees);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    updateReviewerType() {
      if (this.selectedReviewer === 'Line Manager') {
        this.reviewerType = 'Line Manager';
      } else {
        this.reviewerType = 'Other';
      }
    },
    getReviewPeriod() {
      // console.log('revperiod: ', this.displayedQuestions);
      if (this.displayedQuestions[0]) {
        let start = new Date(
          this.displayedQuestions[0].review_start_date
        ).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
        let end = new Date(
          this.displayedQuestions[0].review_end_date
        ).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
        let due = new Date(
          this.displayedQuestions[0].reviewer_due_date
        ).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });

        this.displayDetails.reviewPeriod = `Appraisal Period: ${start} to ${end}`;
        this.displayDetails.reviewDate = `Review Date:  ${due}`;
      }
    },

    initializeSelect2() {
      $(this.$refs.employeesSelect)
        .select2()
        .on('change', () => {
          this.selectedEmployees = $(this.$refs.employeesSelect).val();
        });
    },

    getLastFormId() {
      axios
        .get(this.$hostName + '/getLastFormId')
        .then((response) => {
          this.formId = response.data + 1;
          // console.log('response: ', response.data);
          // console.log('id: ', this.formId);
        })
        .catch((error) => console.error(error));
    },

    getDetailsOfSelectedEmployees(val) {
      this.selectedEmployees = val;
      this.selectedEmployeesInfo = {};

      if (this.selectedEmployees.length == 0) {
        this.displayedQuestions = [];
      } else {
        this.selectedEmployees.forEach((ele) => {
          this.getDetailsOfSelectedEmployee(ele);
        });
      }
    },

      async fetchReviewers() {
        try {
          const response = await axios.get(this.$hostName + '/active-reviewers');
          this.reviewers = response.data; // Update reviewers data array
          // console.log('fetchReviewers() called successfully');
          // console.log('data of employes',this.reviewers)
        } catch (error) {
          console.error('Error fetching reviewers:', error);
        }
      },

    async getDetailsOfSelectedEmployee(id) {
      await this.getQuestionsOfSelectedEmployees();

      if (this.displayedQuestions[0] && this.createMode == false) {
        this.review_start_date = this.displayedQuestions[0].review_start_date;
        this.initialReviewStartDate = this.review_start_date;
        this.review_end_date = this.displayedQuestions[0].review_end_date;
        this.initialReviewEndDate = this.review_end_date;
        this.reviewer_due_date = this.displayedQuestions[0].reviewer_due_date;
        // this.selectedReviewer = this.displayedQuestions[0].selectedReviewer;
        this.initialselectedReviewer = this.selectedReviewer;
        // this.reviewerType = this.displayedQuestions[0].reviewerType;
        this.initialreviewerType = this.reviewerType;
        this.initialReviewerDueDate = this.reviewer_due_date;
        this.published = this.displayedQuestions[0].published ? true : false;
        this.submitted = this.displayedQuestions[0].submitted ? true : false;
        this.reviewerSubmitted = this.displayedQuestions[0].reviewer_submitted
          ? true
          : false;
        if (this.published) {
          this.hideSelect = true;
        } else {
          this.hideSelect = false;
        }
      } else {
        this.review_start_date = '';
        this.review_end_date = '';
        this.reviewer_due_date = '';
        this.published = false;
        this.hideSelect = false;
      }

      await axios
        .post(this.$hostName + '/myInfo', {
          year: new Date().getFullYear(),
          empId: id,
        })
        .then((response) => {
          this.selectedEmployeeInfo = response.data;
          let id = response.data[0].employeeData[0].employee_id;
          this.selectedEmployeesInfo[id] = response.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {});
        // console.log(' this.selectedReviewer', this.selectedReviewer);
        // console.log('this.reviewerType', this.reviewerType);
    },

    setActiveTab(tabId, tab) {
      this.activeTab = tabId;
      this.tabQuestions = tab.questions;
      if (this.activeTab == 1) {
        this.getAllSections();
      }
    },

    checkSelectedDepartments() {
      // console.log('tab:', this.section[this.activeTab]);
      if (this.selectedDepartments.length == 0) return false;
      else return true;
    },

    async getAllSections() {
        const formId = parseInt(this.formId); // Assuming formId is stored in your component's data
        const ids = this.employeeId; // Assuming selectedIds is an array stored in your component's data

        // Log the formId and ids
        // console.log('Form ID:', formId);
        // console.log('IDs:', ids);

        // this.loading = true;
        await axios
          .post(this.$hostName + '/getAllSections', {
              form_id: formId,
              ids: ids
          })
          .then((response) => {
            this.section = [];
            for (let each of response.data) {
              let obj = {};
              obj.id = each.id;
              obj.name = each.section_name;
              obj.questions = each.performance_management_questions;
              this.section.push(obj);
            }
            // console.log('this is the section log', this.section);

            this.getQuestionsOfSelectedEmployees();
          })
          .catch((error) => console.error(error))
          .finally(() => {
            // this.loading = false;
          });
      },
    addNewSection() {
      Swal.fire({
        title: 'Add a new section',
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        html: `
        <div>
            <label>Section name: <input id="section_name" type="text" name="section_name" style="margin-left: 20px" maxLength="100"></label>
        </div>
        `,
        preConfirm: () => {
          let section_name = document.getElementById('section_name').value;
          return section_name;
        },
        customClass: {
          confirmButton: 'mr-2',
          cancelButton: 'ml-2',
        },
      }).then((response) => {
        if (response.isConfirmed) {
          let section_name = response.value;
          axios
            .post(this.$hostName + '/storeSection', {
              section_name: section_name,
            })
            .then(() => {
              this.getAllSections();
            })
            .catch((error) => console.error(error));
        }
      });
    },
    toggleNewQuestion() {
      this.showNewQuestion = !this.showNewQuestion;
    },
    submitNewQuestion() {
      // console.log('submit new question exicuted');
      if (
        this.selectedDepartments.length == 0 ||
        this.selectedEmployees.length == 0
      ) {
        Swal.fire({
          title: 'Error',
          text: 'Please select atleast one employee from one department to create the form',
          icon: 'error',
        });
      } else if (this.review_start_date == '' || this.review_end_date == '') {
        Swal.fire({
          title: 'Error',
          text: 'Please select review start and end dates',
          icon: 'error',
        });
      } else if (this.reviewer_due_date == '') {
        Swal.fire({
          title: 'Error',
          text: 'Please select reviewer due date',
          icon: 'error',
        });
      } else {
        this.showNewQuestion = false;

        this.selectedEmployees.forEach((id) => {
          axios
            .post(this.$hostName + '/attachQuestion', {
              form_id: this.formId,
              section_id: this.activeTab,
              question_text: this.questionInput,
              description_text: this.descriptionInput,
              departments_array: this.selectedDepartments,
              employee_id: id,
              reviewer_id:
                this.selectedEmployeesInfo[id][0].employeeData[0].reporting_to,
              review_end_date: this.review_end_date,
              review_start_date: this.review_start_date,
              reviewer_due_date: this.reviewer_due_date,
              selectedReviewer:this.selectedReviewer,
              reviewerType:this.reviewerType,
            })
            .then(() => {
              this.getAllSections();
              // this.getQuestionsOfSelectedEmployees();
              // this.getDetails();
              this.questionInput = '';
              this.descriptionInput = '';
              // this.selectedDepartments = [];
            })
            .catch((error) => console.error(error))
            .finally(() => {});
        });
        // this.getAllSections();
      }
      // console.log('this is the review due date information', this.reviewerType );
    },
    async getDepartments() {
      // this.loading = true;
      await axios
        .get(this.$hostName + '/getAllDepertments')
        .then((response) => {
          this.departments = response.data; // Update departments array
          this.departmentsForMultiSelect = [{ id: 'All', text: 'All' }];
          this.departments.map((obj) => {
            this.departmentsForMultiSelect.push({
              id: obj.deparment,
              text: obj.deparment,
            });
          });
        })
        .catch((error) => {
          console.error('Error fetching departments:', error);
        })
        .finally(() => {
          // this.loading = false;
        });
    },

    async getQuestionsOfSelectedEmployees() {
      await axios
        .get(this.$hostName + '/getAllQuestions', {
          params: {
            ids: this.selectedEmployees,
            form_id: this.formId,
          },
        })
        .then((response) => {
          let receivedData = response.data;
          receivedData.forEach((eachQuestion) => {
            if(eachQuestion.employee_id == this.selectedEmployee && eachQuestion.form_id == this.formId) {
              this.displayedQuestions.push(eachQuestion);

              if((this.formType == 'My Forms' || this.formType == 'Team Forms') && eachQuestion.final_submitted) {
                this.finalComments = eachQuestion.final_comments;
              } else if(this.formType == 'All Forms') {
                this.finalComments = eachQuestion.final_comments;
              }

              this.finalSubmitted = eachQuestion.final_submitted;
            }
          })
          // this.displayedQuestions = response.data;
          this.reviewerType = this.displayedQuestions[0].reviewer_type;
          this.selectedReviewer = this.displayedQuestions[0].selectedReviewer;
          this.published = this.displayedQuestions[0].published ? true : false;
          this.submitted = this.displayedQuestions[0].submitted ? true : false;
          this.reviewerSubmitted = this.displayedQuestions[0].reviewer_submitted
            ? true
            : false;
          // console.log('questions:', this.displayedQuestions);
        });
    },

    // this method is for selecting all departments
    toggleSelectAllDepartments() {
      if (this.selectAllDepartments) {
        this.selectedDepartments = this.departments.map(
          (department) => department.id
        );
      } else {
        this.selectedDepartments = [];
      }
    },
    handleChange(val) {
      if (this.createMode) {
        this.getLastFormId();
      }

      this.review_start_date = '';
      this.review_end_date = '';
      this.reviewer_due_date = '';
      this.selectedEmployee = '';
      if (val[0] == 'All' || val.includes('All')) {
        this.selectedDepartments = this.departmentsForMultiSelect.slice(1);
      } else {
        this.selectedDepartments = val;
      }
    },

    async fetchEmployeesByDepartments() {
      // Convert the Proxy object to a regular array
      const selectedDepartmentsArray = Array.from(this.selectedDepartments);
      // console.log('inp:', selectedDepartmentsArray);

      if (selectedDepartmentsArray.length > 0) {
        axios
          .post(this.$hostName + '/filterEmployeesByDepartment', {
            department_names: selectedDepartmentsArray.map(
              (department) => department
            ),
          })
          .then((response) => {
            let employees = [];
            response.data.forEach((each) => {
              employees.push({
                id: each.empid,
                text: `${each.empid} - ${each.name}`,
              });
            });
            this.employees = employees;
            // console.log('emp: ', this.employees);
          })
          .catch((error) => {
            console.error('Error fetching employees:', error);
          })
          .finally(() => {});
      } else {
        this.employees = [];
      }

      // this.employees = ['test'];
      // this.$refs.employeesSelect.$el.select2();
    },

    filterBasedOnSelectedDepts(
      question,
      departmentsOfQuestion,
      empOfQuestion = '',
      userId,
      isPublsihed
    ) {
      if (
        userId == 'ADM01' ||
        this.permissions.includes('Performance-Management-Permission')
      ) {
        for (let dept of departmentsOfQuestion) {
          if (
            this.selectedDepartments.includes(dept) &&
            (this.selectedEmployee == empOfQuestion ||
              this.selectedEmployees.includes(empOfQuestion)) &&
            this.formId == question.form_id
          ) {
            // this.displayedQuestions[question.id] = question;
            return true;
          }
          // else if(this.selectedDepartments.includes(dept) && (this.selectedEmployee == '' || this.selectedEmployees.length == 0)) {
          //   return true;
          // }
        }
        return false;
      } else {
        if (departmentsOfQuestion.includes(this.empDept)) {
          if (empOfQuestion != userId && empOfQuestion == null) {
            return true;
          } else if (empOfQuestion == userId && isPublsihed == true) {
            return true;
          }
          return false;
        }
        // return false;
      }
    },
    receiveDataFromQuestion(val, type, questionId) {
      if (type == 'Employee Response') {
        this.bufferObj.empResponse = val;
        this.bufferObj.questionId = questionId;
      } else if (type == 'Reviewer Response') {
        this.bufferObj.revResponse = val;
        this.bufferObj.questionId = questionId;
      } else if (type == 'Final Comments') {
        this.bufferObj.finResponse = this.finalComments;
        this.bufferObj.questionId = questionId;
      }
    },
    addToProgress(eventData) {
      // console.log('allresp: ', this.allResponses);
      if (!this.allResponses[eventData.questionId]) {
        this.allResponses[eventData.questionId] = {};
      }
      // console.log('allresp: ', this.allResponses);
      this.allResponses[eventData.questionId].progress = eventData.progress;
    },

    clearBufferObj(id) {
      // console.log('allresp: ', this.allResponses);
      if (this.allResponses[id]) {
        this.allResponses[id].questionId = this.bufferObj.questionId;
        if (this.bufferObj.hasOwnProperty('empResponse')) {
          this.allResponses[id].empResponse = this.bufferObj.empResponse;
        } else if (this.bufferObj.hasOwnProperty('revResponse')) {
          this.allResponses[id].revResponse = this.bufferObj.revResponse;
        } else if (this.bufferObj.hasOwnProperty('finResponse')) {
          this.allResponses[id].finResponse = this.bufferObj.finResponse;
        }
      } else {
        this.allResponses[id] = this.bufferObj;
      }

      // this.allResponses[id] = this.bufferObj;
      this.bufferObj = {};
    },

    getCompletedTasks(ogTab) {
      let tab = JSON.parse(JSON.stringify(ogTab));
      return tab.filter(
        (ele) =>
          ele.progress == 'Complete' &&
          ele.form_id == this.formId &&
          ele.employee_id == this.selectedEmployee
      ).length;
    },

    showLoading() {
      this.loading = true;
    },

    saveChanges(showSavePopup) {
      // this.loading = true;

      let dataForQuestions = [];

      this.$refs.questionComponents.forEach(component => {
        let requestData = {};
        requestData.id = component.questionId;
        requestData.question_text = component.questionInput;
        requestData.description_text = component.descriptionInput;
        if (this.review_start_date != this.initialReviewStartDate) {
          requestData.appraisal_start_date = this.review_start_date;
        }
        if (this.review_end_date != this.initialReviewEndDate) {
          requestData.appraisal_end_date = this.review_end_date;
        }
        if (this.selectedReviewer != this.initialselectedReviewer) {
          requestData.selectedReviewer = this.selectedReviewer;
        }
        if (this.reviewerType != this.initialreviewerType) {
          requestData.reviewerType = this.reviewerType;
        }
        if (this.reviewer_due_date != this.initialReviewerDueDate) {
          requestData.reviewer_due_date = this.reviewer_due_date;
        }
        dataForQuestions.push(requestData);
        component.showEditQuestion = false;
        });
      // console.log('dataaaaaaaaaaaa' , dataForQuestions);

      axios.post(this.$hostName + '/updateQuestions', {
        dataForQuestions: dataForQuestions, formId: this.formId
      })
      .then(() => {

        this.loading = false;
        if (this.review_end_date != this.initialReviewEndDate) {  
          // console.log('calling mail for end date:', this.selectedEmployee);
          this.sendEmail('PM Form Employee End Date Extended');
        }
        if (this.reviewer_due_date != this.initialReviewerDueDate) { 
          // console.log('calling mail for due date');
          this.sendEmail('PM Form Reviewer Due Date Extended');
        }
        if(showSavePopup) {
          Swal.fire({
            title: 'Successful',
            icon: 'success',
            text: 'Your changes have been saved',
          });
        }
      })
      .catch(error => {
        this.loading = false;
        console.error(error);
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: 'Something went wrong, try again later',
        });
      });

      // this.$refs.questionComponents.forEach((component) => {
      //   let updatePromise = component.updateChanges(component.questionId);
      //   if (this.review_start_date != this.initialReviewStartDate) {
      //     console.log('calling save start dates');
      //     let dateUpdatePromise = component.updateChanges(
      //       component.questionId,
      //       this.review_start_date
      //     );
      //     datePromises.push(dateUpdatePromise);
      //   }
      //   if (this.review_end_date != this.initialReviewEndDate) {
      //     console.log('calling save end dates');
      //     let dateUpdatePromise = component.updateChanges(
      //       component.questionId,
      //       null,
      //       this.review_end_date
      //     );
      //     datePromises.push(dateUpdatePromise);
      //   }
      //   if (this.reviewer_due_date != this.initialReviewerDueDate) {
      //     console.log('calling save due dates');
      //     let dateUpdatePromise = component.updateChanges(
      //       component.questionId,
      //       null,
      //       null,
      //       this.reviewer_due_date
      //     );
      //     datePromises.push(dateUpdatePromise);
      //   }
      //   updatePromises.push(updatePromise);
      // });

      // Promise.all(updatePromises)
      //   .then(() => {
      //     this.loading = false;
      //     Swal.fire({
      //       title: 'Successful',
      //       icon: 'success',
      //       text: 'Your changes have been saved',
      //     });
      //   })
      //   .catch((error) => {
      //     this.loading = false;
      //     console.error(error);
      //     Swal.fire({
      //       title: 'Error',
      //       icon: 'error',
      //       text: 'Something went wrong, try again later',
      //     });
      //   });

      // Promise.all(datePromises)
      // .then(() => {
      //   this.sendEmail('PM Form Employee End Date Extended');
      // })
      // .catch((error) => {
      //   console.error(error);
      //   Swal.fire({
      //     title: 'Error',
      //     icon: 'error',
      //     text: "Due dates could not be extended due to some error, please try again later",
      //   });
      // });

      this.getAllSections();
    },

    saveForm(showSavePopup) {
      this.$refs.questionComponents.forEach((component) => {
        component.uploadFile(component.questionId);
      });

      this.$refs.questionComponents.forEach(component => {
        component.dropDownIsOpen = false;
      });

      let promises = [];

      // console.log('allresponses: ', this.allResponses);
      console.log(promises, showSavePopup);
      let dataForRequest = [];
      for (let each in this.allResponses) {
        let requestData = {};
        requestData.id = each;
        requestData.employee_response = this.allResponses[each].empResponse;
        requestData.reviewer_response = this.allResponses[each].revResponse;
        requestData.final_comments = this.allResponses[each].finResponse;
        requestData.progress = this.allResponses[each].progress;
        dataForRequest.push(requestData);
      }

      axios.post(this.$hostName + '/updateQuestions', {
        dataForQuestions: dataForRequest, formId: this.formId
      })
      .then(() => {
        if(showSavePopup) {
          Swal.fire({
            title: 'Saved',
            icon: 'success',
            text: 'Your form has been saved',
          });
        }
      })
      .catch((error) => {
        console.error(error);
        Swal.fire({
          title: 'Error',
          icon: 'error',
          text: 'Something went wrong, please try again later',
        });
      });
      setTimeout(()=>this.getAllSections(), 3000);
      // Promise.all(promises)
      //   .then(() => {
      //     if(showSavePopup) {
      //       Swal.fire({
      //         title: 'Saved',
      //         icon: 'success',
      //         text: 'Your form has been saved',
      //       });
      //     }
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //     Swal.fire({
      //       title: 'Error',
      //       icon: 'error',
      //       text: 'Something went wrong, please try again later',
      //     });
      //   });
    },

    submitForm() {
      if (this.formType == 'My Forms') {
        Swal.fire({
          title: 'Are you sure you want to submit?',
          text: 'The form will be sent to the reviewer and you will not be able to edit it once submitted',
          icon: 'info',
          showConfirmButton: true,
          showCancelButton: true,
          customClass: {
            confirmButton: 'mr-2',
            cancelButton: 'ml-2',
          },
        }).then((response) => {
          if (response.isConfirmed) {
            this.saveForm(false);
            
            let idsOfShownQuestions = this.displayedQuestions.map(ele => ele.id);

            let dataForRequest = idsOfShownQuestions.map(ele => {
              return {
                id: ele,
                submitted: true,
              };
            });
            // console.log('data:', dataForRequest);

            axios.post(this.$hostName + '/updateQuestions', {
              dataForQuestions: dataForRequest, formId: this.formId
            })
            .then(() => {
              Swal.fire({
                title: 'Submitted!',
                icon: 'success',
                text: 'Your form has been successfully submitted',
              });
              this.$router.go(-1);
              this.sendEmail('PM Form Submitted');
            })
            .catch((error) => {
              console.error(error);
              Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Something went wrong, please try again later',
              });
            });
            // let promises = this.displayedQuestions.map((ele) => {
            //   axios
            //     .patch(this.$hostName + '/updateQuestion', {
            //       id: ele.id,
            //       submitted: true,
            //     })
            //     .catch((error) => console.error(error));
            // });

            // Promise.all(promises)
            //   .then(() => {
            //     Swal.fire({
            //       title: 'Submitted!',
            //       icon: 'success',
            //       text: 'Your form has been successfully submitted',
            //     });
            //     this.$router.go(-1);
            //     this.sendEmail('PM Form Submitted');
            //   })
            //   .catch((error) => {
            //     console.error(error);
            //     Swal.fire({
            //       title: 'Error',
            //       icon: 'error',
            //       text: 'Something went wrong, please try again later',
            //     });
            //   });
          }
        });
      } else if (this.formType == 'Team Forms') {
        Swal.fire({
          title: 'Are you sure you want to submit?',
          text: 'Your responses will be visible to the employee and you will not be able to edit it once submitted',
          icon: 'info',
          showConfirmButton: true,
          showCancelButton: true,
          customClass: {
            confirmButton: 'mr-2',
            cancelButton: 'ml-2',
          },
        }).then((response) => {
          if (response.isConfirmed) {
            let idsOfShownQuestions = this.displayedQuestions.map(ele => ele.id);
            this.saveForm(false);

            let dataForRequest = idsOfShownQuestions.map(ele => {
              return {
                id: ele,
                reviewer_submitted: true,
              };
            });
            // console.log('data:', dataForRequest);

            axios.post(this.$hostName + '/updateQuestions', {
              dataForQuestions: dataForRequest, formId: this.formId
            })
            .then(() => {
              Swal.fire({
                title: 'Submitted!',
                icon: 'success',
                text: 'Your form has been successfully submitted',
              });
              this.$router.go(-1);
              this.sendEmail('PM Form Reviewed');
            })
            .catch((error) => {
              console.error(error);
              Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Something went wrong, please try again later',
              });
            });

            // let promises = this.displayedQuestions.map((ele) => {
            //   axios
            //     .patch(this.$hostName + '/updateQuestion', {
            //       id: ele.id,
            //       reviewer_submitted: true,
            //     })
            //     .catch((error) => console.error(error));
            // });
          }
        });
      } else if (this.formType == 'All Forms') {
        Swal.fire({
          title: 'Are you sure you want to submit?',
          text: 'Your responses will be visible to the employee and you will not be able to edit it once submitted',
          icon: 'info',
          showConfirmButton: true,
          showCancelButton: true,
          customClass: {
            confirmButton: 'mr-2',
            cancelButton: 'ml-2',
          },
        }).then((response) => {
          if (response.isConfirmed) {
            let idsOfShownQuestions = this.displayedQuestions.map(ele => ele.id);
            this.saveForm(false);

            let dataForRequest = idsOfShownQuestions.map(ele => {
              return {
                id: ele,
                final_submitted: true,
              };
            });
            // console.log('data:', dataForRequest);

            axios.post(this.$hostName + '/updateQuestions', {
              dataForQuestions: dataForRequest, formId: this.formId
            })
            .then(() => {
              Swal.fire({
                title: 'Submitted!',
                icon: 'success',
                text: 'Your form has been successfully submitted',
              });
              this.$router.go(-1);
              this.sendEmail('PM Form Reviewed');
            })
            .catch((error) => {
              console.error(error);
              Swal.fire({
                title: 'Error',
                icon: 'error',
                text: 'Something went wrong, please try again later',
              });
            });

            // let promises = this.displayedQuestions.map((ele) => {
            //   axios
            //     .patch(this.$hostName + '/updateQuestion', {
            //       id: ele.id,
            //       reviewer_submitted: true,
            //     })
            //     .catch((error) => console.error(error));
            // });
          }
        });
      }
    },

    sendEmail(type) {
      axios.post(this.$hostName + '/sendEmailForPM', {
        formId: this.formId,
        type: type,
        employeeId: this.selectedEmployee,
      });
    },

    publishForm() {
      if (this.selectedDepartments.length == 0 || this.selectedEmployee == '') {
        Swal.fire({
          title: 'Error',
          text: 'Please select atleast one employee from one department to create the form',
          icon: 'error',
        });
      } else if (this.review_start_date == '' || this.review_end_date == '') {
        Swal.fire({
          title: 'Error',
          text: 'Please select review start and end dates',
          icon: 'error',
        });
      } else {
        this.saveChanges(false);
        let idsOfShownQuestions = this.displayedQuestions.map((ele) => ele.id);

        Swal.fire({
          title: 'Are you sure you want to publish?',
          text: 'This will make the form available to the employees',
          icon: 'question',
          showCancelButton: true,
          customClass: {
            confirmButton: 'mr-2',
            cancelButton: 'ml-2',
          },
        }).then((response) => {
          if (response.isConfirmed) {
            let dataForRequest = idsOfShownQuestions.map(ele => {
              return {
                id: ele,
                published: true,
              };
            });
            // console.log('data:', dataForRequest);

            axios.post(this.$hostName + '/updateQuestions', {
              dataForQuestions: dataForRequest, formId: this.formId
            })
            .then(() => {
              Swal.fire({
                  title: 'Published',
                  icon: 'success',
                });
                this.goBack();
                this.sendEmail('PM Form Published');
            })
            .catch(error => {
              console.error(error) ;
              Swal.fire({
                title: 'Error', 
                icon: 'error', 
                text: 'Something went wrong, please try again later',
              });
            });
          }
        });
      }
    },

    async setDefaultOptions() {
      if (this.$route.params.departments && this.$route.params.id) {
        this.emp_department = this.$route.params.departments
        this.employeeId = this.$route.params.id;
        this.formIsBeingEdited = true;
        this.createMode = false;

        // console.log('dept:', this.$route.params.departments);
        this.selectedDepartments = [this.$route.params.departments];
        this.fetchEmployeesByDepartments();
        let empFromParams = `${this.$route.params.id}`;
        // console.log('empfromparams:', empFromParams);
        this.selectedEmployee = empFromParams;
        this.selectedEmployees.push(empFromParams);

        this.formId = this.$route.params.formId;
        this.formType = this.$route.params.formType;
        // console.log('formType: ', this.formType);

        // this.getDetailsOfSelectedEmployee();
        if (this.selectedEmployee) {
          this.loading = true;
          await this.getDetailsOfSelectedEmployee(this.selectedEmployee);
          await this.dateValidation();
          this.selectedDepartments = [
            this.selectedEmployeeInfo[0].employeeData[0].department.deparment,
          ];
          this.selectedDepartment =
            this.selectedEmployeeInfo[0].employeeData[0].department.deparment;
          this.loading = false;
        }
        // this.hideSelect = true;

        // this.getQuestionsOfSelectedEmployees();
        if (
          this.displayDetails.reviewPeriod == '' ||
          this.displayDetails.reviewDate == ''
        ) {
          this.getReviewPeriod();
        }
      } else {
        this.createMode = true;
      }
      this.loading = false;
    },

    async dateValidation() {
      await axios
        .get(this.$hostName + '/dateValidation', {
          params: {
            employeeId: this.selectedEmployee,
            formId: this.formId,
          },
        })
        .then((response) => {
          this.formStatus = response.data.status;

          if (this.formType == 'My Forms') {
            if (this.formStatus == 'Inactive') {
              this.dateCheck = true;
            } else if (this.formStatus == 'Close') {
              this.submitted = true;
              this.reviewerSubmitted = true;
            } else if (this.formStatus == 'In Review') {
              this.submitted = true;
            }
          } else if (
            this.formType == 'Team Forms' &&
            this.formStatus == 'Inactive'
          ) {
            this.dateCheck = true;
          } else if (
            this.formType == 'Team Forms' &&
            this.formStatus == 'Close'
          ) {
            this.reviewerSubmitted = true;
          }
        })
        .catch((error) => console.error(error));
    },

    showSave() {
      // this.showSaveButton = true;
    },

    checkForEachQuestion(question) {
      // Create an object to store unique text values
      let uniqueTexts = {};

      // Use filter() and reduce() to filter out duplicates
      let filteredArray = this.displayedQuestions.filter((obj) => {
        if (!uniqueTexts[obj.question_text]) {
          uniqueTexts[obj.question_text] = true;
          return true;
        }
        return false;
      });
      return filteredArray.some((ele) => ele.id == question.id);
    },

    goBack() {
      this.$router.go(-1);
    },

    deleteForm() {
      Swal.fire({
        title: 'Are you sure you want to delete form?',
        icon: 'info',
        text: 'Confirming this will delete the form',
        showCancelButton: true,
        customClass: {
          cancelButton: 'ml-2',
        },
      }).then((response) => {
        if (response.isConfirmed) {
          axios
            .delete(this.$hostName + '/deleteForm', {
              params: {
                employee_id: this.selectedEmployee,
                form_id: this.formId,
              },
            })
            .then((response) => {
              Swal.fire({
                title: 'Successful',
                icon: 'success',
                text: response.message,
              });
              this.goBack();
            })
            .catch((error) => console.error(error));
        }
      });
      // this.getQuestionsOfSelectedEmployees();
    },
  },
};
</script>

<style scoped>
* {
  font-family: Montserrat;
  box-sizing: border-box;
}

.page-title-container {
  margin-left: 80px;
  margin-top: 20px;
}

.details-container {
  background-color: #d05959;
  color: white;
  font-size: 0.9rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  column-count: 2;
  column-gap: 10px;
  row-gap: 20px;
  height: auto;
  border-radius: 10px;
  margin-top: 20px;
}

.nav-container {
  margin: 20px 0px 20px 0px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 120px;
}

.nav .nav-pills {
  display: flex;
  z-index: -20;
}

.nav-link.active {
  /* background-color: #f32e79 !important; */
  background: linear-gradient(
    to right,
    rgb(12, 8, 65) 0%,
    rgb(83, 72, 245) 60%
  );
  background-size: 200% 100%;
  background-position: 0 0;
  /* position: relative;
  height: 110%;
  top: -5%; */
  animation: color-in 0.5s ease-in-out;
}

.nav-link {
  background-color: rgb(202, 191, 233) !important;
  /* animation: color-in 3s linear; */
}

.nav-link:hover {
  background-color: rgb(176, 167, 201) !important;
}

.arrow-button {
  /* background-color: #007bff; Button background color */
  /* border: 1px solid black !important; */
  /* color: white; */
  padding: 10px 40px;
  cursor: pointer;
  position: relative;
  /* overflow: hidden; */
  clip-path: polygon(0% 0%, 90% 0%, 100% 50%, 90% 100%, 0% 100%, 10% 50%);
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

@keyframes color-in {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: 0 0;
    /* background-size: 200% 100%; */
  }
}

.btn-container {
  margin-left: auto;
}

/* .new-section-btn {
  position: relative;
  top: 0px;
  right: 0px;
} */

.tab-content {
  padding-top: 20px;
}

.new-question-container {
  /* display: none !important; */
  padding: 20px;
  box-shadow: 2px 2px 8px rgb(87, 87, 87);
  border-radius: 10px;
}

.new-section-container {
  width: 330px;
  position: absolute;
  top: 10px;
  margin-left: auto;
  box-shadow: 2px 2px 10px black;
  padding: 20px;
}

.tab-pane {
  animation: generalSectionAnimation 0.8s ease-in-out;
}

@keyframes generalSectionAnimation {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.v-enter-active {
  transition: opacity 0.8s ease-in-out;
}
.v-leave-active {
  transition: opacity 0.3s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.general-enter-active {
  transition: opacity 3s ease-in-out;
}
.general-leave-active {
  transition: opacity 3s ease;
}

.general-enter-from,
.general-leave-to {
  opacity: 0;
}

.custom-actions {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
}

.custom-confirm-button {
  margin-right: 20px !important;
}

.tab-pane {
  transition: all 0.3s ease;
}

.action-buttons-container {
  margin: 20px 0px 0px 0px;
  box-shadow: 2px 2px 10px black;
  padding: 15px 60px 10px;
  /* border-radius: 10px 10px 0px 0px; */
  position: absolute;
  bottom: 0px;
  background-color: rgb(235, 235, 235);
  z-index: 999;
  width: 100%;

  }

.action-buttons-holder {
  display: flex;
  width: 100%;
  /* margin-left: auto; */
  justify-content: center;
}

.sleeve {
  width: 82%;
  overflow-y: scroll;
  /* box-shadow: 4px -2px 8px rgb(0, 0, 0);
  z-index: 9999999; */
}
/* Define styles for the select element */
.custom-select {
  width: 300px;
  height: 38px;
  background-color: white;
  border: 1px solid #aaa;
  border-radius: 4px;
}

.custom-select:focus-visible {
  outline: none;
}

.custom-select:focus {
  outline: none;
  border-color: transparent !important;
  border: 1px solid #aaa;
}

.reportee {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.reportee:hover {
  cursor: pointer;
}
</style>
